export const servicesData = [
  {
    id: 1,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 2,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 3,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 4,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, , {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, , {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, , {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, , {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  },

]

export const servicesHeadCells = [
  {id: "agriBusinessName", numeric: false, disablePadding: true, label: "Business name"},
  {id: "agriBusinessPoc", numeric: false, disablePadding: false, label: "Provider"},
  {id: "agriBusinessPocContact", numeric: false, disablePadding: false, label: "Provider Contact",},
  {id: "agriServiceRange", numeric: true, disablePadding: false, label: "area"},
  {id: "dealsIn", numeric: false, disablePadding: false, label: "description"},
  {id: "action", numeric: true, disablePadding: false, label: "actions"},
];

export const vendorsHeadCells = [
  {id: "id", disablePadding: true, label: "ID"},
  {id: "vendorName", disablePadding: false, label: "vendor name"},
  {id: "coverageArea", disablePadding: false, label: "coverage area",},
  {id: "action", numeric: true, disablePadding: false, label: "actions"},
];
export const vendorsData=[
  {id:1,vendorName:'Sed pulvinar', coverageArea:'pakistan', },
  {id:2,vendorName:'Sed pulvinar', coverageArea:'pakistan', },
  {id:3,vendorName:'Sed pulvinar', coverageArea:'pakistan', },
  {id:4,vendorName:'Sed pulvinar', coverageArea:'pakistan', },
  {id:5,vendorName:'Sed pulvinar', coverageArea:'pakistan', },
  {id:6,vendorName:'Sed pulvinar', coverageArea:'pakistan', },
]
export const supplierHeadCells=[
  {id: "id", disablePadding: true, label: "ID"},
  {id: "businessName", disablePadding: true, label: "business name"},
  {id: "serviceName", disablePadding: true, label: "service Name"},
  {id: "coverage area", disablePadding: true, label: "coverage area"},
  {id: "action", disablePadding: true, label: "actions"},
]

export const supplierData=[
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
  {id:'001',businessName:'Sed pulvinar',serviceName:'Est venenatis', coverageArea:'pakistan', },
]
